import React, { useState, useEffect } from 'react';
import { useParams, Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
// Keep Alert and CircularProgress for loading/error states
import { CircularProgress, Alert } from '@mui/material';

const Story = () => {
  const { slug } = useParams();
  const navigate = useNavigate();
  const [story, setStory] = useState(null);
  const [previousStory, setPreviousStory] = useState(null);
  const [nextStory, setNextStory] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    fetchStory();
  }, [slug]);

  const fetchStory = async () => {
    try {
      setLoading(true);
      const response = await axios.get(`/api/stories/${slug}`);
      setStory(response.data.story);

      // Fetch navigation data
      const navResponse = await axios.get(`/api/stories/${slug}/navigation`);
      setPreviousStory(navResponse.data.previous);
      setNextStory(navResponse.data.next);
    } catch (error) {
      console.error('Error fetching story:', error);
      if (error.response?.status === 404) {
        setError('Verhaal niet gevonden');
      } else {
        setError('Kon het verhaal niet laden');
      }
    } finally {
      setLoading(false);
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };

  const createMarkup = (htmlContent) => {
    return { __html: htmlContent };
  };

  if (loading) {
    return (
      <div style={{ textAlign: 'center', marginTop: '2rem' }}>
        <CircularProgress />
        <p>Verhaal wordt geladen...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div style={{ marginTop: '2rem' }}>
        <Alert severity="error" sx={{ mb: 2 }}>
          {error}
        </Alert>
        <button className="blue-button" onClick={() => navigate('/stories')}>
          Terug naar verhalen
        </button>
      </div>
    );
  }

  if (!story) {
    return null;
  }

  const imageUrl = story.image_url ? `${import.meta.env.VITE_API_URL}${story.image_url}` : null;

  console.log("Attempting to load image from:", imageUrl);

  return (
    <div className="individual-story-page">
      {/* Story header with image and title */}
      <div className="story-header-section">
        {story.image_url ? (
          <div className="story-title-image-section">
            <div className="story-bar-container">
              <div className="story-bar-top"></div>
              <div className="story-bar-bottom"></div>
            </div>
            <div className="story-title-left">
              <h1 className="story-main-title">{story.title}</h1>
              <p className="story-publish-date">Geschreven op: {formatDate(story.published_date)}</p>
            </div>
            <div className="story-image-right">
              <img
                src={imageUrl}
                alt={story.image_alt || story.title}
                className="story-header-image"
              />
            </div>
          </div>
        ) : (
          <>
            <h1 className="story-main-title">{story.title}</h1>
            <p className="story-publish-date">Geschreven op: {formatDate(story.published_date)}</p>
            <hr className="blue-line" />
          </>
        )}
      </div>

      {/* Story content with Gelasio font */}
      <div
        className="story-content story-content-gelasio"
        dangerouslySetInnerHTML={createMarkup(story.content)}
      />

      {/* Navigation */}
      <div className="story-navigation">
        <div className="nav-buttons">
          {previousStory ? (
            <Link to={`/stories/${previousStory.slug}`} className="nav-button nav-previous">
              <span className="nav-arrow">&lt;</span>
              <div className="nav-text">
                <span className="nav-label">vorig verhaal</span>
                <span className="nav-title">{previousStory.title}</span>
                <span className="nav-date">{formatDate(previousStory.published_date)}</span>
              </div>
            </Link>
          ) : (
            <div className="nav-button nav-placeholder"></div>
          )}

          {nextStory ? (
            <Link to={`/stories/${nextStory.slug}`} className="nav-button nav-next">
              <div className="nav-text">
                <span className="nav-label">volgend verhaal</span>
                <span className="nav-title">{nextStory.title}</span>
                <span className="nav-date">{formatDate(nextStory.published_date)}</span>
              </div>
              <span className="nav-arrow">&gt;</span>
            </Link>
          ) : (
            <div className="nav-button nav-placeholder"></div>
          )}
        </div>

        <Link to="/stories" className="blue-button centered-button">
          Terug naar alle verhaaltjes
        </Link>
      </div>
    </div>
  );
};

export default Story;